<script lang="ts">
  import { placePath } from "../../support/links";
  import StatusTable from "../status-table.svelte";
  import { getNow } from "../../data/clock";
  import { getStatusNote } from "../../domain/status";

  export let time = getNow();
  export let schedule = [];
  export let showSubtitle = false;

  $: entries = schedule.map(({ place }) => {
    return {
      title: place.title,
      subtitle: place.parentTitle,
      statusNote: getStatusNote(place, $time),
      href: placePath(place)
    };
  });

  const sortFields = ["title", "time", "timeEnd"];
</script>

<StatusTable
  color="var(--color-status-red)"
  title="Closed"
  icon="icon-close"
  detail=""
  sortField={sortFields}
  {showSubtitle}
  {entries}
/>
